/*
 *  This file hrone-avatar.component.ts is part of HROne Inbox. The intelectual property owned by Uneecops Workplace Solution PVT. LTD.
 *  CopyrightYear: 2024
 *  (C) 2015-2024. All Right reserved. Uneecops Workplace Solution PVT. LTD.
 *
 */

import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnDestroy, QueryList, ViewChildren } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HroneAvatarService } from './hrone-avatar.service';

@Component({
    selector: 'app-hrone-avatar',
    imports: [CommonModule],
    templateUrl: './hrone-avatar.component.html',
    styleUrls: ['./hrone-avatar.component.scss']
})
export class HroneAvatarComponent implements OnChanges, AfterViewInit, OnDestroy {
  @ViewChildren('AvararRef') AvararRef!: QueryList<ElementRef>;
  @Input() src = '';
  @Input() name = '';
  @Input() size = '35'
  showFirstCharacters = '';

  constructor(private readonly avatarService: HroneAvatarService) { }

  ngOnChanges(): void {
    const arrayOfName = this.name?.split(' ')
    if (arrayOfName?.length) {
      this.showFirstCharacters = arrayOfName?.map(name => name?.charAt(0))?.reduce((acc, value) => acc + value,'')
    }

  }

  ngAfterViewInit(): void {
    this.setAvatarProperties();
  }

  handleImageError() {
    this.src = '';
    this.setAvatarProperties();
  }

  setAvatarProperties(): void {
    this.avatarService.setColor(this.name);
    if (this.AvararRef) {
      this.AvararRef.forEach((element: ElementRef) => {
        if (element?.nativeElement) {
          element.nativeElement.style.height = `${this.size}px`;
          element.nativeElement.style.width = `${this.size}px`;
          element.nativeElement.style.fontSize = `${+this.size / 3}px`;
          element.nativeElement.style.backgroundColor = this.src ? '' : this.avatarService.userColorCode.get(this.name)
        }
      });
    }
  }

  ngOnDestroy(): void {
    this.avatarService.userColorCode.clear()
  }
}
